"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Value = exports.Label = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactComponents = require("@cimpress/react-components");

var _lodash = _interopRequireDefault(require("lodash.camelcase"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: 10px;\n  flex: 1.5;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  max-width: 200px;\n  flex: 0.5;\n  color: ", ";\n  font-weight: 600;\n  margin: 6px 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: baseline;\n  flex: 1;\n  word-break: break-word;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FieldContainer = _styledComponents["default"].div(_templateObject());

var Label = _styledComponents["default"].h6(_templateObject2(), _reactComponents.colors.shale);

exports.Label = Label;

var Value = _styledComponents["default"].div(_templateObject3());

exports.Value = Value;

var FieldDisplay = function FieldDisplay(_ref) {
  var name = _ref.name,
      value = _ref.value;
  return _react["default"].createElement(FieldContainer, null, _react["default"].createElement(Label, {
    "data-testid": "fieldDisplayLabel-".concat((0, _lodash["default"])(name))
  }, name), _react["default"].createElement(Value, null, value));
};

FieldDisplay.propTypes = {
  name: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].node
};
FieldDisplay.defaultProps = {
  value: undefined
};
var _default = FieldDisplay;
exports["default"] = _default;